import { render, staticRenderFns } from "./PaymentCardDetails.vue?vue&type=template&id=0630f16d&scoped=true&"
import script from "./PaymentCardDetails.vue?vue&type=script&lang=js&"
export * from "./PaymentCardDetails.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCardDetails.vue?vue&type=style&index=0&id=0630f16d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0630f16d",
  null
  
)

export default component.exports